import { Card, Checkbox, Col, Form, Input, Radio, Row, Select, Space } from "antd";
import Footer from "../../../components/common/Footer";
import React from "react";

import FormAction from "../../../components/common/FormAction";
import PageHeading from "../../../components/common/PageHeading/index";
import RightBar from "../../../components/common/RightBar";

import "./AccountingSettings.css";

const AccountingSettingsRightBar = [];

function AccountingSettings() {
  return (
    <>
      <div className="page-container">
        <div className="accounting-settings main-container">
          <PageHeading heading="Accounting Settings" />
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 11 }}
            initialValues={{ remember: true }}
            autoComplete="off"
            className="form-container"
            colon={false}
          >
            <Row>
              <Col span={24}>
                <Card title="Rent Key Accounts">
                <Form.Item label="Rent Income Account">
                  <Select showSearch allowClear placeholder="Rent income account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Additional Rent Income Accounts">
                  <Select showSearch allowClear placeholder="Additional rent income accounts here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label=" ">
                  <button className="button-link">Add Another Account</button>
                </Form.Item>
                <Form.Item label="Subsidized Rent Income Accounts">
                  <Select showSearch allowClear placeholder="Subsidized rent income accounts here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label=" ">
                  <button className="button-link">Add Another Account</button>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Other Key Accounts">
                <Form.Item label="Operating Cash Account">
                  <Select showSearch allowClear placeholder="Operating cash account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Escrow Cash Account">
                  <Select showSearch allowClear placeholder="Escrow cash account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Accounts Recieveable Account">
                  <Select showSearch allowClear placeholder="Accounts recieveable account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Accounts Payable Account">
                  <Select showSearch allowClear placeholder="Accounts payable account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Prepayment Account">
                  <Select showSearch allowClear placeholder="Prepayment account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Owner Disbursements Account">
                  <Select showSearch allowClear placeholder="Owner disbursements account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Retained Earnings Account">
                  <Select showSearch allowClear placeholder="Retained earnings account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Management Fees Account">
                  <Select showSearch allowClear placeholder="Management fees account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Lease Fee Account">
                  <Select showSearch allowClear placeholder="Lease fee account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Renewal Fee Account">
                  <Select showSearch allowClear placeholder="Renewal fee account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Maintenance Fees Account">
                  <Select showSearch allowClear placeholder="Maintenance fees account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Tax Authority Account">
                  <Select showSearch allowClear placeholder="Tax authority account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Tax Passthru Account">
                  <Select showSearch allowClear placeholder="Tax passthru account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Application Fees Account">
                  <Select showSearch allowClear placeholder="Application fees account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Security Clearing Account">
                  <Select showSearch allowClear placeholder="Security clearing account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Insurance Income Account">
                  <Select showSearch allowClear placeholder="Insurance income account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Insurance Admin Fees Account">
                  <Select showSearch allowClear placeholder="Insurance admin fees account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Late Fee Account">
                  <Select showSearch allowClear placeholder="Late fee account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="NSF Fees Account">
                  <Select showSearch allowClear placeholder="NSF fees account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Interest Account">
                  <Select showSearch allowClear placeholder="Interest account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="MTM Additional Fee Account">
                  <Select showSearch allowClear placeholder="MTM additional fee account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Association Income Account">
                  <Select showSearch allowClear placeholder="Association income account here">
                    <Select.OptGroup>2345</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Security Deposite Account">
                  <Select showSearch allowClear placeholder="Security deposite account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Holding Deposite Account">
                  <Select showSearch allowClear placeholder="Holding deposite account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Additional Deposite Account">
                  <Select showSearch allowClear placeholder="Additional deposite account here">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label=" ">
                  <button className="button-link">Add Another Account</button>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Key Accounts for GPR Reporting & Automated Application of Rent Concession Credits">
                <Form.Item label="Rent Consession Accounts">
                    <Select showSearch allowClear placeholder="Rent consession account here">
                      <Select.OptGroup>None</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label=" ">
                    <button className="button-link">Add Another Account</button>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Key Accounts for GPR Journal Entries">
                  <Form.Item label="Vacancy Loss Account">
                    <Select showSearch allowClear placeholder="Vacancy loss account here">
                      <Select.OptGroup>None</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Delinquency Loss Account">
                    <Select showSearch allowClear placeholder="Delinquency loss account here">
                      <Select.OptGroup>2345</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Loss/Gain to Market Account">
                    <Select showSearch allowClear placeholder="Loss/Gain to market account here">
                      <Select.OptGroup>None</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Gross Potential Rent Account">
                    <Select showSearch allowClear placeholder="Gross potential rent account here">
                      <Select.OptGroup>2345</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Modal Loss Account">
                    <Select showSearch allowClear placeholder="Modal loss account here">
                      <Select.OptGroup>None</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Renovation Loss Account">
                    <Select showSearch allowClear placeholder="Renovation loss account here">
                      <Select.OptGroup>None</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Office Loss Account">
                    <Select showSearch allowClear placeholder="Office loss account here">
                      <Select.OptGroup>None</Select.OptGroup>
                    </Select>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Receipts">
                  <Form.Item label="Apply receipts to charges in the following order">
                    <Radio.Group>
                      <Space direction="vertical">
                        <Radio value="oldest first"> Oldest First </Radio>
                        <Radio value="newest first"> Newest First </Radio>
                        <Radio value="gl account order"> GL Account Order </Radio>
                        <Radio value="gl account order current month first">
                          Newest First
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                  <h4>
                    Receipts will be applied first to the following GL accounts.
                    For non-selected GL accounts, receipts will be applied to the
                    oldest charges.
                  </h4>
                  <ul className="list-items-container">
                    <li>
                      <span>Drag</span> the accounts around to change the order.
                    </li>
                    <li>
                      <span>Click</span> an x to remove an account.
                    </li>
                    <li>
                      <span>Select</span> an account from More Accounts to add an
                      account.
                    </li>
                  </ul>
                  <Form.Item label="GL Account Order">
                    <Select showSearch allowClear placeholder="-- More Accounts --">
                      <Select.OptGroup>None</Select.OptGroup>
                    </Select>
                  </Form.Item>
                  <Form.Item label=" ">
                    <p className="plain-text">105: Security Deposit Liability</p>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="CAM Recoverables">
                  <Form.Item label="Sort GL Accounts in GL Account Groups by">
                    <Radio.Group>
                      <Space direction="vertical">
                        <Radio value="gl account number">
                          {" "}
                          GL Account Number{" "}
                        </Radio>
                        <Radio value="order added to gl account group">
                          Order added to GL Account Group
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Bill Approvals">
                  <Form.Item label=" ">
                    <Checkbox>Enable Bill Approvals</Checkbox>
                  </Form.Item>
                  <Form.Item label=" ">
                    <Checkbox>Redirect last approver to Payables page after approving bill</Checkbox>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
               <Card title="Association Board Invoice Approvals">
                  <Form.Item label=" ">
                    <Checkbox>Enable Board Approval of Invoices</Checkbox>
                  </Form.Item>
               </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Fund Accounts">
                <Row align="center">
                  <Col span={9}>
                    <ul className="input-ul">
                      <li>00 Operating</li>
                      <li>01 Reserve</li>
                    </ul>
                  </Col>
                </Row>
                <Form.Item label=" ">
                  <Input />
                </Form.Item>
                <Form.Item label=" ">
                  <button className="button-link">Add Another Fund Account</button>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Cost Centers">
                  <Form.Item label=" ">
                    <Checkbox>Enable Cost Centers</Checkbox>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Check Writing">
                <Form.Item label="Select Bills for Payment up to">
                  <Radio.Group>
                    <Space direction="vertical">
                      <Radio value="gl account number">
                        Reserve amount set for property
                      </Radio>
                      <Radio value="order added to gl account group">
                        Available Funds
                      </Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
                <Form.Item label="Separate Names on Tenant Checks with">
                  <Select showSearch allowClear placeholder="OR">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <h3>Management Company Check Defaults</h3>
                <Form.Item label="Consolidation">
                  <Select showSearch allowClear placeholder="Consolidation">
                    <Select.OptGroup>None</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label="Memo">
                  <Input />
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Fees">
                <Form.Item label="Automatically post late fees at">
                  <Select showSearch allowClear placeholder="Automatically post late fees at">
                    <Select.OptGroup>Noon</Select.OptGroup>
                  </Select>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Automatically waive all unposted late fees</Checkbox>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title='"Automatic "Certified Funds Only"'>
                <Form.Item label=" ">
                  <Checkbox>Automatically set residents to pay with Certified Funds Only</Checkbox>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Proration">
                <Form.Item label=" ">
                  <Checkbox>Apply lease renewal proration by default</Checkbox>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Apply move out proration by default</Checkbox>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Use second month proration</Checkbox>
                </Form.Item>
                <Form.Item label="Proration Settings">
                  <Select showSearch allowClear placeholder="Actual days in month">
                    <Select.Option>Noon</Select.Option>
                  </Select>
                </Form.Item>
               <Form.Item label=" ">
               <p className="plain-text">
                  Proration is Calculated as: Rent ÷ Actual number of days that
                  month
                </p>
               </Form.Item>
                <Form.Item label="Round Prorated Charges">
                  <Select showSearch allowClear placeholder="Never round charges">
                    <Select.Option>Never round charges</Select.Option>
                  </Select>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Recurring Charges">
                <Form.Item label=" ">
                  <Checkbox>Allow Non-Monthly Recurring Charges</Checkbox>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Reports">
                <Form.Item label=" ">
                  <Checkbox>Show Remit Due on Owner's Statements</Checkbox>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Show Work Order Discounts and Markups on Owner's Statements</Checkbox>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Override Vendor Name on Owner's Statements</Checkbox>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Suppress Prepayments from Owner's Statement</Checkbox>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card title="Budgeting">
                <Form.Item label="Over Budget Notification">
                  <Checkbox>
                    Display an alert when a bill or purchase order is over the
                    property's monthly budgeted amount for a GL account.
                  </Checkbox>
                </Form.Item>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
               <Card title="Bills">
               <Form.Item label="Automatically calculate bill due dates as">
                  <Select showSearch allowClear placeholder="Automatically calculate bill due dates as">
                    <Select.Option>Never round charges</Select.Option>
                  </Select>
                </Form.Item>
                <p className="plain-text left-p">
                  Bills from vendors with no payment terms set will use these
                  payment terms
                </p>
                <Form.Item label=" ">
                  <Checkbox>Enable hold bills</Checkbox>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Hide duplicate bills in payment batch</Checkbox>
                </Form.Item>
               </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
               <Card title="Accrual Accounting">
               <Form.Item label=" ">
                  <Checkbox>Enable Accrual Accounting</Checkbox>
                </Form.Item>
                <Form.Item label=" ">
                  <Checkbox>Make Posting Date match Invoice Date by default</Checkbox>
                </Form.Item>
               </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
               <Card title="Vendor Compliance Controls">
               <h4>
                  Vendors with expired insurance certification dates in AppFolio
                  will be subject to the following internal controls until their
                  insurance is up-to-date:
                </h4>
                <ul className="list-items-container">
                  <li>
                    Cannot create a work order or purchase order for this vendor
                  </li>
                  <li>
                    Cannot create a bill from the work order or the purchase
                    order for this vendor
                  </li>
                  <li>Cannot create a recurring bill for this vendor</li>
                  <li>
                    Cannot pay a bill to this vendor; however, a bill can be
                    created under Payables
                  </li>
                </ul>
                <Form.Item label=" ">
                  <Checkbox>Enable Vendor Compliance controls</Checkbox>
                </Form.Item>
               </Card>
              </Col>
            </Row>
            <FormAction />
          </Form>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={AccountingSettingsRightBar} />
      </div>
    </>
  );
}

export default AccountingSettings;
